/* Simple Shopify wishlist — stores product handles in localStorage */
(function () {
  'use strict';

  var STORAGE_KEY = 'wishlist';
  var CARD_SECTION = 'wishlist-card';

  function getList() {
    try {
      var data = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function saveList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function has(handle) {
    return getList().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = getList();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle);
    else list.splice(i, 1);
    saveList(list);
    return i === -1; // true = added
  }

  function remove(handle) {
    saveList(getList().filter(function (h) { return h !== handle; }));
  }

  /* ---------- UI sync ---------- */

  function updateButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = has(btn.dataset.productHandle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active);
    });
  }

  function updateCount() {
    var count = getList().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function toggleEmptyState() {
    var grid = document.getElementById('wishlist-grid');
    var empty = document.getElementById('wishlist-empty');
    var actions = document.getElementById('wishlist-actions');
    var isEmpty = !!grid && grid.children.length === 0;
    if (empty) empty.hidden = !isEmpty;
    if (actions) actions.hidden = isEmpty;
  }

  /* ---------- Wishlist page (uses the theme's own product card) ---------- */

  function renderPage() {
    var grid = document.getElementById('wishlist-grid');
    if (!grid) return;

    var handles = getList();

    if (!handles.length) {
      grid.innerHTML = '';
      toggleEmptyState();
      return;
    }

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '?section_id=' + CARD_SECTION)
          .then(function (r) {
            if (!r.ok) throw new Error('not found');
            return r.text();
          })
          .then(function (html) {
            return { handle: handle, html: html };
          })
          .catch(function () {
            remove(handle); // deleted or unpublished product
            return null;
          });
      })
    ).then(function (items) {
      grid.innerHTML = items
        .filter(Boolean)
        .map(function (item) {
          return '<div class="wishlist-item" data-wishlist-item="' + item.handle + '">' + item.html + '</div>';
        })
        .join('');
      updateButtons();
      updateCount();
      toggleEmptyState();
    });
  }

  /* ---------- Add all to cart ---------- */

  function shopRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function showMessage(text) {
    var el = document.getElementById('wishlist-message');
    if (!el) return;
    el.textContent = text;
    el.hidden = !text;
  }

  function addAllToCart(btn) {
    var handles = getList();
    if (!handles.length) return;

    var labelEl = btn.querySelector('[data-wishlist-add-all-label]') || btn;
    var label = labelEl.textContent;
    btn.disabled = true;
    labelEl.textContent = 'Adding...';
    showMessage('');

    var skipped = 0;

    // 1) Read the cart so we never add a product that is already in it
    fetch(shopRoot() + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = {};
        cart.items.forEach(function (item) { inCart[item.product_id] = true; });

        // 2) Look up each wishlist product and pick its first available variant
        return Promise.all(
          handles.map(function (handle) {
            return fetch(shopRoot() + 'products/' + handle + '.js')
              .then(function (r) { return r.json(); })
              .then(function (p) {
                if (inCart[p.id]) {
                  skipped++;
                  return null;
                }
                var variant = p.variants.filter(function (v) { return v.available; })[0];
                return variant ? { id: variant.id, quantity: 1 } : null;
              })
              .catch(function () { return null; });
          })
        );
      })
      .then(function (items) {
        items = items.filter(Boolean);

        // Everything is already in the cart — just take the customer there
        if (!items.length && skipped) return null;
        if (!items.length) throw new Error('unavailable');

        // 3) Add only what is missing
        return fetch(shopRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('failed');
        });
      })
      .then(function () {
        window.location.href = shopRoot() + 'cart';
      })
      .catch(function () {
        btn.disabled = false;
        labelEl.textContent = label;
        showMessage('Sorry, some products could not be added to the cart. Please try again.');
      });
  }

  /* ---------- Events ---------- */

  document.addEventListener('click', function (e) {
    var addAllBtn = e.target.closest('[data-wishlist-add-all]');
    if (addAllBtn) {
      addAllToCart(addAllBtn);
      return;
    }

    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;

    e.preventDefault(); // the button sits inside a card link
    e.stopPropagation();

    var added = toggle(btn.dataset.productHandle);
    updateButtons();
    updateCount();

    // On the wishlist page, un-hearting removes the card
    if (!added) {
      var item = btn.closest('[data-wishlist-item]');
      if (item) {
        item.remove();
        toggleEmptyState();
      }
    }
  });

  // Keep multiple tabs in sync
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) {
      updateButtons();
      updateCount();
      renderPage();
    }
  });

  function init() {
    updateButtons();
    updateCount();
    renderPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Call Wishlist.refresh() after dynamic content loads (filters, infinite scroll, quick view)
  window.Wishlist = { get: getList, has: has, toggle: toggle, refresh: updateButtons };
})();